exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header_z9wQ1 {\n    text-align: center;\n    width: 100%;\n}\n\n.gapMilitaryService_3UzNW {\n    height: 20px;\n}\n\n.customTitle_1NWxB {\n    font-size: 16px;\n    margin: 20px 0;\n    background-color: black;\n    color: white;\n    text-align: center;\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n\n.laidOffTitle_1jdLw {\n    font-size: 17px;\n    margin: 10px 0 0 0;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    font-weight: 800;\n}\n", ""]);

// exports
exports.locals = {
	"header": "header_z9wQ1",
	"gapMilitaryService": "gapMilitaryService_3UzNW",
	"customTitle": "customTitle_1NWxB",
	"laidOffTitle": "laidOffTitle_1jdLw"
};